import { render, staticRenderFns } from "./DataKartuAnggotaBiasa.vue?vue&type=template&id=1d32dd55&scoped=true&"
import script from "./DataKartuAnggotaBiasa.vue?vue&type=script&lang=js&"
export * from "./DataKartuAnggotaBiasa.vue?vue&type=script&lang=js&"
import style0 from "./DataKartuAnggotaBiasa.vue?vue&type=style&index=0&id=1d32dd55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32dd55",
  null
  
)

export default component.exports